import React from 'react';
import { X } from 'lucide-react';

interface InlineVideoPlayerProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  title?: string;
  className?: string;
}

const InlineVideoPlayer: React.FC<InlineVideoPlayerProps> = ({
  isOpen,
  onClose,
  videoUrl,
  title = "CRMONCE Demo Video",
  className = "relative w-full h-64 md:h-80 rounded-2xl overflow-hidden"
}) => {
  if (!isOpen) return null;

  return (
    <div className={className}>
      <iframe
        src={videoUrl}
        title={title}
        className="w-full h-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
      <button
        onClick={onClose}
        className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
        aria-label="Close video"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default InlineVideoPlayer; 